const colors = {
    white: '#ffffff',
    black: '#000000',
    grey_0: '#6A6A6A',
    grey_1: '#EBEBEB',
    blue_1: '#1E2B51',
    blue_2: '#D0D8E4',
    blue_3: '#6E85AE',
    blue_4: '#6EADE4',
    blue_5: '#6EADE4',
};

export const theme = {
    background: colors.white,
    footerBackground: colors.black,
    footerBackground_2: colors.grey_1,

    text_1: colors.black,
    text_2: colors.white,
    clickText: colors.blue_1,
    moreDetails: colors.grey_0,

    button: colors.blue_1,

    imageBackground: colors.grey_1,
    inputBorder: colors.black,

    main: colors.blue_1
};